import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  formatMemberClaim,
  getTextWithToolTip,
} from './riskPatientDetailsHelper';
import MedicalHistoryDetails from '../../_components/organisms/MedicalHistoryDetails';
import React from 'react';
import { getEnrollemntStatusChip } from './riskProfileHelper';
import { numberToCurrencyFormatter, wrongValuesNeglected } from './helper';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  dropDownMenuItemsAlphabets,
  dropDownMenuItemsValues,
} from './tableSortHelper';
import { DottedText } from './financialForensicsHelper';

export const columnsDropdownOptions = [
  'Member ID',
  'Chronic Conditions',
  'Diagnosis',
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
  'Total Cost',
  'Previous Year Cost',
  'Total Medical Cost',
  'Total Rx Cost',
  'Previous Year Medical Cost',
  'Previous Year Rx Cost',
  'Enrollment Status',
  'Trigger Conditions',
  'Costliest Drugs',
  'Gender',
  'Age',
  'Recent Visit',
  // 'First Name',
  // 'Last Name',
  'Member Relationship',
  'DOB',
];

export const cohortColumnsDropdownOptions = [
  'Member ID',
  'Chronic Conditions',
  'Multiple Drugs Usage',
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
  'Total Cost',
  'Previous Year Cost',
  'Total Medical Cost',
  'Total Rx Cost',
  'Previous Year Medical Cost',
  'Previous Year Rx Cost',
  'Enrollment Status',
  'Trigger Conditions',
  'Costliest Drugs',
  'Gender',
  'Age',
  'Recent Visit',
  // 'First Name',
  // 'Last Name',
  'Member Relationship',
  'DOB',
];

export const defaultColumns = [
  'Member ID',
  'Chronic Conditions',
  'Diagnosis',
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
];

export const defaultGLPColumns = [
  'Member ID',
  'Enrollment Status',
  'Chronic Conditions',
  'Diagnosis',
  'Costliest Drugs',
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
];

export const specialityDrugColumns = [
  'Member ID',
  'Enrollment Status',
  'Chronic Conditions',
  'Diagnosis',
  'Costliest Drugs',
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
];

export const defaultRiskPatientColumns = [
  'Member ID',
  'Recent Visit',
  'Chronic Conditions',
  'Diagnosis',
  'Trigger Conditions',
  'Total Cost',
  'Previous Year Cost',
];

export const triggerCondDefaultColumns = [
  'Member ID',
  'Trigger Conditions',
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
];

export const costColumns = [
  'Total Cost (Medical + Rx)',
  'Previous Year Cost (Medical + Rx)',
  'Total Cost',
  'Previous Year Cost',
  'Total Medical Cost',
  'Total Rx Cost',
  'Previous Year Medical Cost',
  'Previous Year Rx Cost',
  'Plan Paid',
  'Total Paid',
  'Claim Count',
  'Age',
  'Plan Paid Cost',
  'Claim Count',
  'Previous Claim Count',
];

export const getCohortDefaultColumns = (type: string) => {
  switch (type) {
    case 'chronic':
      return [
        'Member ID',
        'Enrollment Status',
        'Chronic Conditions',
        'Total Cost (Medical + Rx)',
        'Previous Year Cost (Medical + Rx)',
      ];
    case 'cost':
      return [
        'Member ID',
        'Enrollment Status',
        'Chronic Conditions',
        'Total Cost (Medical + Rx)',
        'Previous Year Cost (Medical + Rx)',
      ];
    case 'drugs':
      return [
        'Member ID',
        'Enrollment Status',
        'Multiple Drugs Usage',
        'Total Cost (Medical + Rx)',
        'Previous Year Cost (Medical + Rx)',
      ];
    case 'members':
      return [
        'Member ID',
        'Enrollment Status',
        'Chronic Conditions',
        'Total Cost (Medical + Rx)',
        'Previous Year Cost (Medical + Rx)',
      ];
    default:
      return [];
  }
};

export const alphabetsColumns = [
  'First Name',
  'Last Name',
  'Procedure',
  'Type Of Service',
  'Place Of Service',
];

export const getColumnValueFormat = (
  columnName: string,
  fieldValue: any,
  onClick?: any,
) => {
  switch (columnName) {
    case 'Chronic Conditions':
    case 'Trigger Conditions':
      return fieldValue?.length !== 0
        ? getTextWithToolTip(fieldValue, 38, {}, 'top-start')
        : '-';
    case 'Enrollment Status':
      return getEnrollemntStatusChip(fieldValue);
    case 'Costliest Drugs':
      return fieldValue?.length !== 0
        ? getTextWithToolTip(
            fieldValue?.map(
              (drug: any) =>
                `${drug?.drug_name}(${numberToCurrencyFormatter(
                  drug?.totalPaid,
                )})`,
            ),
            30,
          )
        : '-';
    case 'Procedure':
      const formattedText =
        fieldValue.length > 30
          ? getTextWithToolTip(fieldValue, 30)
          : fieldValue;
      if (onClick) {
        return (
          <DottedText
            text={formattedText}
            onClick={() => onClick(fieldValue)}
          />
        );
      }
      return formattedText;
    case 'Total Cost':
    case 'Previous Year Cost':
    case 'Total Medical Cost':
    case 'Total Rx Cost':
    case 'Previous Year Medical Cost':
    case 'Previous Year Rx Cost':
    case 'Plan Paid':
    case 'Total Paid':
    case 'Plan Paid Cost':
      return numberToCurrencyFormatter(fieldValue, true, 2);
    case 'Diagnosis':
      return fieldValue === '-'
        ? '-'
        : getTextWithToolTip(
            fieldValue.map((item: any) => {
              if (item?.diagnosis_desc === '-') {
                return '-';
              }
              return `${item.diagnosis_desc} - ${numberToCurrencyFormatter(
                item.diagnosis_total_paid,
              )}`;
            }),
            30,
          );
    default:
      return fieldValue;
  }
};

export const formatMembersListData = (
  membersListData: any[],
  columns: string[],
) => {
  const tableData: any[] = [];

  if (membersListData?.length > 0) {
    membersListData?.forEach((item: any) => {
      const eachRow: any[] = [];

      Object.keys(item).forEach((key) => {
        if (columns?.includes(key)) {
          let value = item[key];
          // If value is an array, clean it
          if (Array.isArray(value)) {
            value = value.filter(
               
              (v) => !wrongValuesNeglected.includes(v) && v !== undefined,
            );
            if (value.length === 0) {
              return;
            }
          }
          eachRow[columns.indexOf(key)] = getColumnValueFormat(key, value);
        }
      });

      eachRow[columns.length] = (
        <MedicalHistoryDetails
          riskPatientDetails={formatMemberClaim(
            item.claimData,
            item['Member ID'],
          )}
        />
      );

      tableData.push(eachRow);
    });
  }

  return tableData;
};

export const formatProceduresListData = (
  membersListData: any[],
  columns: string[],
  onClick?: any,
) => {
  const tableData: any[] = [];

  if (membersListData?.length > 0) {
    membersListData?.forEach((item: any) => {
      const eachRow: any[] = [];

      Object.keys(item).forEach((key) => {
        if (columns?.includes(key)) {
          eachRow[columns?.indexOf(key)] = getColumnValueFormat(
            key,
            item[key],
            onClick,
          );
        }
      });

      tableData.push(eachRow);
    });
  }

  return tableData;
};

export const getColumns = (
  selectedColumns: string[],
  infoIcon?: any,
  isFirstMemberId: boolean = true,
) => {
  const cellStyles = {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    color: patientAccessTheme.palette.text.mediumemphasis,
  };

  const columns: Columns[] = selectedColumns?.map(
    (item: string, index: number) => {
      const dropdownMenuItems =
        (costColumns?.includes(item) && dropDownMenuItemsValues) ||
        (alphabetsColumns?.includes(item) && dropDownMenuItemsAlphabets);

      const sortItems = {
        showThisColumn: true,
        sortColumnName: getSortFieldName(item),
        DropDownMenuItems: dropdownMenuItems,
      };
      let name: any = item;
      if (item === 'Diagnosis') {
        name = (
          <div
            style={{
              display: 'flex',
              alignItems: 'left',
              fontSize: '12px',
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 500,
            }}
          >
            Diagnosis
            {infoIcon && <div>{infoIcon}</div>}
          </div>
        );
      }

      return {
        name: name,
        align: isFirstMemberId
          ? costColumns?.includes(item)
            ? 'right'
            : 'left'
          : 'left',
        cellStyles: cellStyles,
        width: '',
        cellPadding: isFirstMemberId
          ? index === 0
            ? '8px 18px 8px 48px'
            : '8px 18px 8px 16px'
          : '8px 18px 8px 16px',
        ...(costColumns?.includes(item) || alphabetsColumns?.includes(item)
          ? sortItems
          : {}),
      };
    },
  );

  return columns;
};

export const getSortFieldName = (columnName: string) => {
  switch (columnName) {
    case 'Total Cost (Medical + Rx)':
    case 'Total Cost':
    case 'Total Paid':
      return 'totalCost';
    case 'Previous Year Cost (Medical + Rx)':
    case 'Previous Year Cost':
      return 'previousYearCost';
    case 'Total Medical Cost':
      return 'medicalCost';
    case 'Total Rx Cost':
      return 'rxCost';
    case 'Previous Year Medical Cost':
      return 'prevMedicalCost';
    case 'Previous Year Rx Cost':
      return 'prevRxCost';
    case 'First Name':
      return 'firstName';
    case 'Last Name':
      return 'lastName';
    case 'Plan Paid':
      return 'planPaid';
    case 'Claim Count':
    case 'Claims':
      return 'claimCount';
    case 'Age':
      return 'age';
    case 'Multiple Drugs Usage':
      return 'drugUsage';
    case 'Procedure':
      return 'procedure';
    case 'Type Of Service':
      return 'typeOfService';
    case 'Place Of Service':
      return 'placeOfService';
    case 'Claim Count':
      return 'claimCount';
    case 'Plan Paid Cost':
      return 'planPaidCost';
    case 'Previous Claim Count':
      return 'previousClaims';
    default:
      return columnName;
  }
};
